export enum PdfWorkFormType {
  WorkForm = 0,
  WorkFormWithParams = 1,
  WorkFormLabelTag89x28 = 2,
  WorkFormLabelTag23x23 = 3,
}
